import React, { ReactElement } from "react";

import ReplayIcon from "@mui/icons-material/Replay";
import Button, { ButtonProps } from "@mui/material/Button";

import { useSelector } from "../../../store";
import { useRunHealthChecksMutation } from "../../../store/pomeriumApi";

const ReRunHealthChecksButton = (): ReactElement => {
  const { organizationId, clusterId } = useSelector((state) => state.current);
  const [triggerRunHealthChecks] = useRunHealthChecksMutation();
  const [busy, setBusy] = React.useState(false);

  const buttonProps: ButtonProps = {
    variant: "contained",
    color: "primary",
    startIcon: <ReplayIcon />,
    children: "Check Again",
    disabled: busy,
  };

  const handleClick = (evt: React.MouseEvent): void => {
    evt.preventDefault();
    setBusy(true);

    setTimeout(() => {
      setBusy(false);
    }, 30000);

    triggerRunHealthChecks({
      organizationId,
      clusterId,
      reRunHealthChecksRequest: {},
    });
  };

  return <Button {...buttonProps} onClick={handleClick} />;
};
export default ReRunHealthChecksButton;
